import {openReportDialog, OpenReportDialog} from "./open-dialog-button/OpenReportDialogButtonComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.components`;

    return angular.module(moduleName, [])
                  .component(OpenReportDialog, openReportDialog())
                  .name;
}
